import script from "./Avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Avatar.vue?vue&type=script&setup=true&lang=ts"

import "./Avatar.vue?vue&type=style&index=0&id=7886c6f6&scoped=true&lang=scss"

import exportComponent from "C:\\repos\\1File_WebClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7886c6f6"]])

export default __exports__